import React, { Component } from 'react'
import { connect } from "react-redux";
import Grid from "../../../../../../components/grid";
import {
    getDeductionSettings, addUpdateSettings, deleteSchedule,
    getCompanyEins, getDeductionCodes, getPayPeriodProfiles,
    runDeductionTool, getCostCenterByCompany
} from "../../../../../../store/actions";
import ScheduleModal from '../../../../../Scheduled-deductions/deductions-schedule/ScheduleModal';
import { format } from "date-fns";
import Edit_icon from "../../../../../../assets/images/edit_icon.png";
import Delete_icon from "../../../../../../assets/images/delete_icon.png";
import { isEqual } from 'lodash';
import OurModal from '../../../../../../components/ourModal';

class DeductionSchedules extends Component {
    state = {
        columnDefs: [
            {
                headerName: "Schedule Name",
                field: "scheduleName",
                width: 150,
                filter: 'agTextColumnFilter',
                sortable: true,
            },
            {
                headerName: "Start Date",
                field: "startDate",
                resizable: true,
                filter: 'agDateColumnFilter',
                sortable: true,
                width: 120,
                valueFormatter: params => params.value ? format(new Date(params.value), 'MMM dd yyyy') : "",
            },
            {
                headerName: "End Date",
                field: "endDate",
                resizable: true,
                width: 120,
                sortable: true,
                filter: 'agDateColumnFilter',
                valueFormatter: params => params.value ? format(new Date(params.value), 'MMM dd yyyy') : "",
            },
            {
                headerName: "Action", field: "", sortable: false, filter: false,
                cellRenderer: (params) => (
                    <>
                        <div className="action">
                            <button className="btn btn-primary" onClick={() => this.btnEdit(params.data)} ><img src={Edit_icon} /></button>{" "}
                            <button className="btn btn-primary" onClick={() => this.btnDelete(params.data._id)}><img src={Delete_icon} /></button>
                        </div>

                    </>)
            }
        ],
        rowData: [],
        editRow: {},
        isEdit: false,
        isShow: false,
        confirmationBox: false,
        deleteId: "",
        isClicked: false,
    };

    async componentDidMount() {
        await this.props.getCostCenterByCompany(this.props.ClientDataReducer._id);
        await this.props.getCompanyEins(this.props.ClientDataReducer.companyShortName);
        await this.props.getDeductionCodes(this.props.ClientDataReducer._id);
        await this.props.getPayPeriodProfiles(this.props.ClientDataReducer._id);
        await this.props.getDeductionSettings({ company: this.props.ClientDataReducer._id });
        this.setState({ rowData: this.props.DeductionSchedulesReducer });
    };

    componentDidUpdate(prevProps, prevState) {
        if (!isEqual(prevProps.DeductionSchedulesReducer, this.props.DeductionSchedulesReducer)) {
            this.setState({ rowData: this.props.DeductionSchedulesReducer })
        };

    };

    btnDelete = (id) => {
        this.setState({ confirmationBox: true, deleteId: id })
    };

    btnEdit = data => {
        this.setState({ isEdit: true, editRow: data, isShow: true })
    };

    deleteSchedule = async (id) => {
        this.setState({ confirmationBox: false })
        return this.props.deleteSchedule(id);
    };

    closeConfirmation = () => {
        this.setState({ confirmationBox: false, deleteId: "" });
    };

    openDeductionSetup = () => {
        let isShow = !this.state.isShow;
        this.setState({ isShow });
    };

    onCloseBtn = () => {
        this.setState({ isShow: false, isEdit: false, editRow: {} });
    };

    runTool = async () => {
        this.setState({ isClicked: true });
        setTimeout(function () { this.setState({ isClicked: false }) }.bind(this), 1000);
        return this.props.runDeductionTool(this.props.ClientDataReducer.companyShortName, this.props.ClientDataReducer._id)
    };

    render() {

        return (
            <>
                <div className="reportListAccording mb-3 mt-0">
                    <button className="btn btn-info" onClick={this.openDeductionSetup}>New Schedule</button>

                    <button
                        className={
                            this.state.isClicked
                                ? "btn btn-info  ms-3"
                                : "btn btn-secondary float-right ms-3"
                        }
                        onClick={this.runTool}
                    >
                        Run Tool Now
                    </button>
                    {this.state.isShow && (
                        <ScheduleModal
                            show={this.state.isShow}
                            isEdit={this.state.isEdit}
                            company={this.props.ClientDataReducer._id}
                            companyName={this.props.ClientDataReducer.companyShortName}
                            settings={this.state.editRow}
                            onClose={this.onCloseBtn}
                        />
                    )}
                </div>
                <div className="shadow_white_box full-box mt-0">
                    <div className="clients_grid">
                        <Grid
                            columnDefs={this.state.columnDefs}
                            rowData={this.state.rowData}
                            height='300px'
                        >
                        </Grid>
                    </div>
                </div>
                {this.state.confirmationBox && (
                    <OurModal
                        onClose={this.closeConfirmation}
                        size="small"
                        centered={true}
                        title="Confirm Delete"
                        onSave={() => this.deleteSchedule(this.state.deleteId)}
                        saveBtnText="Confirm"
                    >
                        <p>Are You Sure that you want to delete?</p>
                    </OurModal>
                )}
            </>
        )
    }
}

const mapStateToProps = ({ UserReducer, ClientDataReducer, DeductionSchedulesReducer, CostCenterReducer, CompanyEinsReducer, DeductionCodesReducer, PayPeriodProfilesReducer, earningsCodes }) =>
    ({ UserReducer, ClientDataReducer, DeductionSchedulesReducer, CostCenterReducer, CompanyEinsReducer, DeductionCodesReducer, PayPeriodProfilesReducer, earningsCodes });
export default connect(mapStateToProps, {
    getDeductionSettings,
    deleteSchedule,
    addUpdateSettings,
    getCompanyEins,
    getDeductionCodes,
    getPayPeriodProfiles,
    getCostCenterByCompany,
    runDeductionTool
})(DeductionSchedules);